import * as React from "react";
import { Outlet } from "react-router-dom";
import { AppProvider } from "@toolpad/core/react-router-dom";
import type { Session } from "@toolpad/core";
import { customTheme } from "./components/theme/customTheme";
import logo from "./images/logo.png";
import {
  NAVIGATION,
  NAVIGATION_USER,
} from "./components/dashboardNavigationStructure";

const BRANDING = {
  title: "E-commerce",
  logo: <img src={logo} alt="App logo" />,
};

export default function App() {
  const admin = true;
  const [session, setSession] = React.useState<Session | null>({
    user: {
      name: "Bharat Kashyap",
      email: "bharatkashyap@outlook.com",
      image: "https://avatars.githubusercontent.com/u/19550456",
    },
  });

  const authentication = React.useMemo(() => {
    return {
      signIn: () => {
        setSession({
          user: {
            name: "Bharat Kashyap",
            email: "bharatkashyap@outlook.com",
            image: "https://avatars.githubusercontent.com/u/19550456",
          },
        });
      },
      signOut: () => {
        setSession(null);
      },
    };
  }, []);

  return (
    <AppProvider
      session={session}
      authentication={authentication}
      theme={customTheme}
      navigation={admin ? NAVIGATION : NAVIGATION_USER}
      branding={BRANDING}
    >
      <Outlet />
    </AppProvider>
  );
}
